<template>
  <section class="product-item">
    <div class="checkbox" v-if="checkbox">
      <van-checkbox :disabled="!product._returned" v-model="checked"></van-checkbox>
    </div>
    <div class="product-info" v-if="product">
      <div>
        <img class="info-img" v-lazy="product.image"/>
      </div>
      <div class="info-box">
        <p class="info-title">{{product.general_name}}</p>
        <p class="info-desc">规格：{{product.norms}}</p>
        <p class="info-desc">厂家：{{product.produce_unit}}</p>
        <p class="info-desc">批号：{{product.batch_code}}</p>
        <div class="info-price-count-box">
          <p class="price" :class="{
            promotion: product._isPromotion
          }" >￥{{(+product.price).toFixed(4)}}</p>
          <van-stepper v-if="stepper" v-model="product._number" :max="+product.quantity" @change="onChange" :min="1" />
          <p class="count" v-if="!product._isPromotion && !stepper">{{quantityText}}{{+product.quantity}}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
import { Stepper } from 'vant'
Vue.use(Stepper)
export default {
  name: 'product-item',
  props: {
    item: {
      default: () => {}
    },
    /**
     * @description 显示选择框
     */
    checkbox: {
      default: true
    },
    /**
     * @description 显示步进器
     */
    stepper: {
      default: false
    },
    quantityText: {
      default: '购买数量：'
    }
  },
  data () {
    return {
      product: this.item,
      checked: this.item._checked,
      // 是否是促销商品
      isPromotion: this.item instanceof Array,
      value: 1
    }
  },
  created () {
    if (this.stepper) {
      this.$set(this.item, '_number', this.item.quantity)
    }
  },
  watch: {
    'item._checked' () {
      this.product._checked = this.item._checked
      this.checked = this.item._checked
    },
    checked () {
      this.product._checked = this.checked
      this.$emit('update:item', this.product)
      this.$emit('change', this.product)
    }
  },
  methods: {
    onChange () {
      this.$emit('change', this.product)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~styles/var.scss';

@import '~styles/mixins.scss';
.product-item {
  @include flex(row);
  align-items: center;
  padding: 10px 0;
  .checkbox {
    padding-left: 5px;
  }
  .product-info {
    @include flex(row);
    flex: 1;
    padding-right: 10px;
    align-items: center;
    .info-img {
      width: 92px;
      height: 92px;
      box-sizing: border-box;
      border: 1px solid $border-color-base;
      margin-left: 10px;
    }
    .info-box {
      padding-left: 15px;
      flex: 1;
      overflow: hidden;
      .info-title {
        font-size: 14px;
        color: $heading-color;
        margin-bottom: 12px;
        line-height: 1;
      }
      .info-desc {
        color: $text-color-secondary;
        font-size: 12px;
        margin-bottom: 8px;
        line-height: 1;
      }
      .info-price-count-box {
        @include flex(row);
        justify-content: space-between;
      }
    }
  }
  .price {
    color: $price-color;
    font-size: 14px;
    line-height: 1;
    &.promotion {
      color: #777;
    }
  }
  .count {
    color: $heading-color;
    font-size: 12px;
    line-height: 1;
  }
}
</style>
